import React from "react";
import PropTypes from "prop-types";

/**
 * Mức ưu tiên của phiếu — một nguồn cho bảng danh sách, filter, trang chi tiết và
 * form. Icon theo quy ước quen thuộc (Jira): ⇈ High · ═ Medium · ⇊ Low — đọc được
 * cả khi không phân biệt màu, và luôn đi kèm nhãn chữ.
 * Phiếu cũ không có priority = Medium (giống mặc định của form).
 */
export const PRIORITY = {
  high: {
    label: "High", icon: "bi-chevron-double-up", iconCls: "tw-text-geist-error",
    pill: "tw-bg-[#fdeceb] tw-text-[#c0362f] tw-border-[#f6cfcc]",
  },
  medium: {
    // Bootstrap Icons không có "=": pause xoay 90° thành hai gạch ngang.
    label: "Medium", icon: "bi-pause tw-inline-block tw-rotate-90", iconCls: "tw-text-geist-warning",
    pill: "tw-bg-[#fff8ee] tw-text-[#b46a00] tw-border-[#f7e2c0]",
  },
  low: {
    label: "Low", icon: "bi-chevron-double-down", iconCls: "tw-text-[#2563eb]",
    pill: "tw-bg-geist-100 tw-text-geist-fg-2 tw-border-geist-border",
  },
};

export const PRIORITY_KEYS = ["high", "medium", "low"];

export const priorityOf = (value) => PRIORITY[value] || PRIORITY.medium;

export const PriorityIcon = ({ value, className = "" }) => {
  const p = priorityOf(value);
  return <i className={`bi ${p.icon} ${p.iconCls} tw-text-[12px] tw-leading-none ${className}`} aria-hidden="true" />;
};

PriorityIcon.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
};

/** Pill trong bảng / trang chi tiết. `suffix` ví dụ " priority". */
export const PriorityPill = ({ value, suffix = "" }) => {
  const p = priorityOf(value);
  return (
    <span className={`tw-inline-flex tw-items-center tw-gap-1 tw-text-[11px] tw-font-medium tw-px-2 tw-py-0.5 tw-rounded-xl tw-border tw-border-solid tw-whitespace-nowrap ${p.pill}`}
      title={`${p.label} priority`}>
      <PriorityIcon value={value} />
      {p.label}{suffix}
    </span>
  );
};

PriorityPill.propTypes = {
  value: PropTypes.string,
  suffix: PropTypes.string,
};

/** Options cho FilterDropdown / SelectDropdown — có icon trước nhãn. */
export const PRIORITY_OPTIONS = PRIORITY_KEYS.map((v) => ({
  value: v, label: PRIORITY[v].label, icon: <PriorityIcon value={v} />,
}));
